function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBwPv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccccff"
    },
    d: "M6.5,7.8c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7S3.9,7.8,6.5,7.8 M6.5,7C3.5,7,1,9.5,1,12.5 S3.5,18,6.5,18s5.5-2.5,5.5-5.5S9.5,7,6.5,7L6.5,7z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ccccff"
    },
    cx: 17.5,
    cy: 12.5,
    r: 5.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBwPv);
export default __webpack_public_path__ + "static/media/img_BwPv.ca58648da8466ce7e9957f93c190754e.svg";
export { ForwardRef as ReactComponent };